import { makeApiRequest } from '../../utils/api-utils';

export const getAllBadges = async () => makeApiRequest('/badge/get-all');
export const getBadgeById = async (id: string) => makeApiRequest(`/badge/get-by-id/${id}`);
export const createBadge = async (data: any) => makeApiRequest('/badge/create', { method: 'POST', body: JSON.stringify(data) });
export const updateBadge = async (id: string, data: any) => makeApiRequest(`/badge/update/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteBadge = async (id: string) => makeApiRequest(`/badge/delete/${id}`, { method: 'DELETE' }); 